'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var MentionContent = function (_React$Component) {
  _inherits(MentionContent, _React$Component);

  function MentionContent() {
    _classCallCheck(this, MentionContent);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MentionContent.prototype.render = function render() {
    console.log('>> MentionContent', this.props);
    return _react2["default"].createElement(
      'span',
      { style: { backgroundColor: '#e6f3ff' } },
      this.props.children
    );
  };

  return MentionContent;
}(_react2["default"].Component);

MentionContent.propTypes = {
  children: _react2["default"].PropTypes.any
};
exports["default"] = MentionContent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-editor-mention/lib/MentionContent.js
 ** module id = 589
 ** module chunks = 0
 **/